import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatDialogClose } from "@angular/material/dialog";

import { SelfserviceAuthenticationBox } from "../selfservice-authentication-box/selfservice-authentication-box";

@Component({
  selector: "selfservice-success",
  templateUrl: "selfservice-success.html",
  styleUrls: ["../selfservice-loader/selfservice-loader.scss", "./selfservice-success.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SelfserviceAuthenticationBox, TranslatePipe, MatDialogClose],
})
export class SelfserviceSuccess {
  message = input<string>();

  protected text = computed(() => this.message() ?? "Selfservice.Global.SuccessText");
}
